export default __webpack_public_path__ + "static/media/img37.e822efc0.jpg";